// client/src/helpers/streamContent.ts — a stream points at one playlist or one video (F7).
import { ILiveStream, IVisualMedia, LiveStreamTypeEnum, VisualMediaTypeEnum } from "../types/models";

export function streamContentName(stream: ILiveStream): string {
  if (stream.type === LiveStreamTypeEnum.video) return stream.video?.name || "-";
  return stream.playlist?.name || "-";
}

/**
 * True when the stream has something to play: at least one playlist item, or a
 * video (radio) stream with at least one background. A freshly provisioned stream
 * has a playlist row with no items, so `playlistId` alone is not enough.
 */
export function streamHasContent(stream: ILiveStream): boolean {
  if (stream.type === LiveStreamTypeEnum.video) {
    return (stream.video?.backgrounds?.length ?? 0) > 0;
  }
  return (stream.playlist?.playlistVisualMedias?.length ?? 0) > 0;
}

export function streamThumbnail(stream: ILiveStream): { url?: string; type?: VisualMediaTypeEnum } {
  let visualMedia: IVisualMedia | undefined;
  if (stream.type === LiveStreamTypeEnum.video) {
    visualMedia = stream.video?.backgrounds?.[0]?.visualMedia;
  } else {
    const first = stream.playlist?.playlistVisualMedias
      ?.slice()
      .sort((a, b) => a.order - b.order)[0];
    visualMedia = first?.visualMedia;
  }
  if (visualMedia?.thubmnailUrl) {
    return { url: visualMedia.thubmnailUrl, type: VisualMediaTypeEnum.image };
  }
  return { url: visualMedia?.url, type: visualMedia?.type };
}
